// ─── Aprire una scheda nuova ─────────────────────────────────────────────────
//
// 🗣️ Voce 25 (25/09/2026, dal mockup approvato): il bottone dice «Salva la
// scheda» (*«è più giusto dire salva scheda che apri scheda»*), e il telefono si
// scrive come viene (⇒ `CampoTelefono.tsx`).
// 📋 Voce 26: il bottone «Aggiungi un socio» sta nella testata della pagina, e
// questo modulo si apre in cima, non più in fondo all'elenco.

import { useState } from 'react';
import { usaCreazioneSocio } from '../../features/soci/dati.js';
import { Campo, Guasto } from '../../components/pezzi.js';
import { CampoTelefono } from './CampoTelefono.js';

export function NuovoSocio({
  chiudi,
  fatto,
}: {
  chiudi: () => void;
  /** Il nome di chi è appena entrato, per la riga «… è nell'anagrafica». */
  fatto: (nome: string) => void;
}): React.JSX.Element {
  const crea = usaCreazioneSocio();
  const [bozza, setBozza] = useState({ firstName: '', lastName: '', email: '', phone: '' });

  return (
    <form
      className="riquadro nuovo-socio"
      onSubmit={(e) => {
        e.preventDefault();
        crea.mutate(
          {
            firstName: bozza.firstName.trim(),
            lastName: bozza.lastName.trim(),
            // ⛔ Stringa vuota ⇒ `null`. Un'email vuota scritta come `''` è un
            // valore per il vincolo di unicità: due soci «senza email»
            // diventerebbero un doppione, e il secondo verrebbe rifiutato con
            // un messaggio che non c'entra niente.
            email: bozza.email.trim() === '' ? null : bozza.email.trim(),
            phone: bozza.phone.trim() === '' ? null : bozza.phone.trim(),
          },
          {
            onSuccess: (s) => fatto(s.displayName),
          },
        );
      }}
    >
      <h3>Socio nuovo</h3>
      <p className="tenue piccolo">
        Il telefono si scrive come viene: con o senza +39, con spazi o trattini. Il gestionale lo mette in
        ordine da solo.
      </p>
      <Campo
        etichetta="Nome"
        required
        value={bozza.firstName}
        onChange={(e) => setBozza({ ...bozza, firstName: e.target.value })}
      />
      <Campo
        etichetta="Cognome"
        required
        value={bozza.lastName}
        onChange={(e) => setBozza({ ...bozza, lastName: e.target.value })}
      />
      <CampoTelefono
        etichetta="Telefono"
        value={bozza.phone}
        onChange={(phone) => {
          // Il rifiuto di prima parlava del numero vecchio: riscrivendolo, sparisce.
          crea.reset();
          setBozza({ ...bozza, phone });
        }}
      />
      <Campo
        etichetta="Email"
        type="email"
        value={bozza.email}
        onChange={(e) => setBozza({ ...bozza, email: e.target.value })}
      />
      <Guasto errore={crea.error} />
      <div className="azioni">
        <button type="submit" disabled={crea.isPending}>
          {crea.isPending ? 'Un attimo…' : 'Salva la scheda'}
        </button>
        <button type="button" className="bordato" onClick={chiudi}>
          Lascia stare
        </button>
      </div>
    </form>
  );
}
